

<div *ngIf="viewMode == 'ARTIC_PLATE_VIEW_MODE'">
<div class="col-12" *ngIf="!analysisPlateView">
  <p-confirmDialog  appendTo="body"></p-confirmDialog>
  <div class="col-12 flex">
    <div class="col-4">
      <p-radioButton name="redoGroup" value="Detail" label="Detail View" [(ngModel)]="val2" inputId="rd3">
      </p-radioButton>
    </div>
    <div class="col-4">
      <p-radioButton [disabled]="!selectedBatch.measuredArticQCDateTime" name="redoGroup" value="Artic" label="Artic Concentration" [(ngModel)]="val2" inputId="rd3">
      </p-radioButton>
    </div>
    <div class="col-4">
      <p-radioButton [disabled]="!selectedBatch.measuredLibQCDateTime" name="redoGroup" value="Library" label="Library Concentration" [(ngModel)]="val2" inputId="rd3">
      </p-radioButton>
    </div>
  </div>
  <div class="col-12 legendBorderWithPadding parentDiv" [hidden]="!showPlateView" *ngIf="val2 === 'Detail'">
    <div class="col-12" style="font-weight: bold;" id="processingTableHeader">
      Legend
    </div>
    <div class="col-12 noPadding">
      <div class="col-12 flex noPadding legendBorder childDiv">
        <div class="col-4 noPadding">
          <svg height="35" width="35">
            <circle cx="20" cy="20" r="10" stroke="black" stroke-width="3" fill="#f0cced" />
          </svg>
           <label class="m-0"> Sample </label> 
        </div>
        <div class="col-4 noPadding">
          <svg height="35" width="35">
            <circle cx="20" cy="20" r="10" stroke="black" stroke-width="3" fill="aqua" />
          </svg>
            <label class="m-0"> Positive Control</label> 
        </div>
        <div class="col-4 noPadding">
          <svg height="35" width="35">
            <circle cx="20" cy="20" r="10" stroke="black" stroke-width="3" fill="yellow" />
          </svg>
            <label class="m-0"> Negative Control </label>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12  noPadding" [hidden]="!showPlateView" *ngIf="val2 == 'Detail'" id="sampleScannerInterface">

      <table data-vertable="ver5" id="scanTable" aria-describedby="Detail View" class="table" style="width: 100%;">
        <thead>
          <tr class="row100 head">
            <th class="column100 column1" scope="col"></th>
            <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders; let k = index"
              [ngStyle]="getColHeaderStyle(k)">{{col}}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
            <td class="column100 column1" [ngStyle]="getRowHeaderStyle(i)">{{row}}</td>
            <td class="column100 column2 noHover"  *ngFor="let col of columnHeaders; let j = index" style="padding:0%"
              (click)="cellSelection(i, j)">
              <input *ngIf="!isScanningAllowed()" class="cellviewsold" pInputText type="text" name="sampleBarcode" dir="rtl"
                [value]="getSampleAt(i, j, plateMap).barcode"   [ngStyle]="getMidplexSampleBoxColor(getSampleAt(i, j, plateMap).barcode)"readonly />
              <input *ngIf="isScanningAllowed()" #scanInput
                [ngClass]="{'cellviewsold': true, 'contamination-font': isContaminated(scanTableArray[getPositionalValue(i, j)]), 'ncSample': isNCSample(scanTableArray[getPositionalValue(i, j)])}"
                id="{{'scanbox_' + getPositionalValue(i, j)}}" pInputText [ngStyle]="getCellStyle(i, j)" type="text"
                name="sampleBarcode" [value]="scanTableArray[getPositionalValue(i, j)].barcode" readonly />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-12 legendBorderWithPadding parentDiv" [hidden]="!showPlateView" *ngIf="['Artic','Library'].includes(val2)">
      <div class="col-12" style="font-weight: bold;" id="processingTableHeader">
        Legend
      </div>
      <div class="col-12 noPadding">
        <div class="col-12 flex noPadding legendBorder childDiv">
          <div class="col-2 noPadding">
            <svg height="35" width="35">
              <rect x="10" y="10" width="20" height="10" stroke="black" stroke-width="1" fill="#E88D8D" />
            </svg>
            <label class="m-0">{{'<0,000'}}</label>
            
          </div>
          <div class="col-2 noPadding">
            <svg height="35" width="35">
              <rect width="20" x="10" y="10" height="10" stroke="black" stroke-width="1" fill="#FFFF40" />
            </svg>
            <label class="m-0">Low</label>
           
          </div>
          <div class="col-2 noPadding">
            <svg height="35" width="35">
              <rect width="20" x="10" y="10" height="10" stroke="black" stroke-width="1" fill="#8DBC7A" />
            </svg>
            <label class="m-0">Good</label>
           
          </div>
          <div class="col-2 noPadding">
            <svg height="35" width="35">
              <rect width="20" height="10" stroke="black" x="10" y="10" stroke-width="1" fill="#4ea3d8" />
            </svg>
            <label class="m-0">High</label>
          </div>
          <div class="col-2 noPadding">
            <label class="m-0">MV = Measured Value</label>
          </div>
          <div class="col-2 noPadding">
            <label class="m-0">DF = Dilution Factor</label>
          </div>
        </div>
      </div>
  
    </div>
  <div class="col-12 noPadding" [hidden]="!showPlateView" *ngIf="['Artic','Library'].includes(val2)" id="sampleScannerInterface">

    
    <div class="col-12" style="padding: 1%;">
      <table  id="scanTable" aria-describedby="Conc View" class="table" style="width: 100%;">
        <thead>
          <tr class="row100 head">
            <th class="column100 column1" scope="col"></th>
            <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders; let k = index"
              [ngStyle]="getColHeaderStyle(k)">{{col}}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
            <td class="column100 column1" [ngStyle]="getRowHeaderStyle(i)">{{row}}</td>
            <td class="column100 column2"  *ngFor="let col of columnHeaders; let j = index" style="padding:0%"
              (click)="cellSelection(i, j)">
              <input pTooltip="{{getToolTip(i,j)}}" [tooltipDisabled]="disableToolTipIf(i, j)" [escape]="false" *ngIf="!isScanningAllowed()" class="cellviewsold" pInputText type="text" name="sampleBarcode"
                [value]="getSampleCaluclatedConcentration(i, j)"
                [style.background-color]="getCellBackgroundColor(i, j)" readonly />
              <input *ngIf="isScanningAllowed()" #scanInput
                [ngClass]="{'cellviewsold': true, 'contamination-font': isContaminated(scanTableArray[getPositionalValue(i, j)]), 'ncSample': isNCSample(scanTableArray[getPositionalValue(i, j)])}"
                id="{{'scanbox_' + getPositionalValue(i, j)}}" pInputText [ngStyle]="getCellStyle(i, j)" type="text"
                name="sampleBarcode" [value]="scanTableArray[getPositionalValue(i, j)].barcode" readonly />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="col-12" *ngIf="analysisPlateView">
  <div class="col-2">
    <p-radioButton name="analysisGroup" value="Read Counts" label="Read Counts" (click)="getBatchQCReport($event, val2)" [(ngModel)]="val2" [disabled]="!selectedBatch.primaryAnalysisImportedDateTime">
    </p-radioButton>
  </div>
  <div class="col-4">
    <p-radioButton name="analysisGroup" value="Mean coverage/Coverage breadth" (click)="getBatchQCReport($event, val2)" [disabled]="!selectedBatch.metricsResultsImportedDateTime"
      label="Mean coverage/Coverage breadth" [(ngModel)]="val2">
    </p-radioButton>
  </div>
  <div class="col-3">
    <p-radioButton  name="analysisGroup" value="Lineage classification" (click)="getBatchQCReport($event, val2)" label="Lineage classification" [disabled]="!selectedBatch.pangolianResultsImportedDateTime"
      [(ngModel)]="val2">
    </p-radioButton>
  </div>
  <div class="col-3">
    <p-radioButton  name="analysisGroup" value="Batch QC Report" (click)="getBatchQCReport($event, val2)"
      label="Batch QC Report" [(ngModel)]="val2">
    </p-radioButton>
  </div>
  <div class="col-12 legendBorderWithPadding parentDiv" [hidden]="!showPlateView" *ngIf="val2 == 'Read Counts'">
    <div class="col-12" style="font-weight: bold;" id="processingTableHeader">
      Legend
    </div>
    <div class="col-12 noPadding">
      <div class="col-12 noPadding legendBorder childDiv">
        <div class="col-3 noPadding">
          <svg height="35" width="35">
            <rect x="10" y="10" width="20" height="10" stroke="black" stroke-width="1" fill="#E88D8D" />
          </svg>
          <label class="m-0">{{'< 3% of planned reads'}}</label>

        </div>
        <div class="col-3 noPadding">
          <svg height="35" width="35">
            <rect width="20" x="10" y="10" height="10" stroke="black" stroke-width="1" fill="#FFFF40" />
          </svg>
          <label class="m-0">{{'3% <= reads < 20%'}}</label>

        </div>
        <div class="col-3 noPadding">
          <svg height="35" width="35">
            <rect width="20" x="10" y="10" height="10" stroke="black" stroke-width="1" fill="#8DBC7A" />
          </svg>
          <label class="m-0">{{'20% <= reads < 200%'}}</label>

        </div>
        <div class="col-3 noPadding">
          <svg height="35" width="35">
            <rect width="20" height="10" stroke="black" x="10" y="10" stroke-width="1" fill="#4ea3d8" />
          </svg>
          <label class="m-0">{{' >= 200% of planned reads'}}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 legendBorderWithPadding parentDive" [hidden]="!showPlateView" *ngIf="val2 == 'Mean coverage/Coverage breadth'">
    <div class="col-12" style="font-weight: bold;" id="processingTableHeader">
      Legend
    </div>
    <div class="col-12 noPadding">
      <div class="col-12 noPadding legendBorder childDiv">
        <div style="text-align:center;text-decoration:underline;font-weight: bold;">(Sample + PC)</div>
        <div class="line"></div>  
        <div class="col-3 noPadding">
          <svg height="35" width="35">
            <rect x="10" y="10" width="20" height="10" stroke="black" stroke-width="1" fill="#ADD8E6" />
          </svg>
          <label class="m-0">{{'coverage breadth  >= 94% '}}</label>
        </div>
        <div class="col-3 noPadding">
          <svg height="35" width="35">
            <rect width="20" x="10" y="10" height="10" stroke="black" stroke-width="1" fill="#90EE90" />
          </svg>
          <label class="m-0">{{'90% <= cb < 94%'}}</label>
        </div>
        <div class="col-3 noPadding">
          <svg height="35" width="35">
            <rect width="20" x="10" y="10" height="10" stroke="black" stroke-width="1" fill="#FFFF00" />
          </svg>
          <label class="m-0">{{'30%  <= cb  < 90%'}}</label>
        </div>
        <div class="col-3 noPadding">
          <svg height="35" width="35">
            <rect width="20" height="10" stroke="black" x="10" y="10" stroke-width="1" fill="#ff6347" />
          </svg>
          <label class="m-0">{{' coverage breadth < 30%'}}</label>
        </div>
        <div class="line"></div>
        <div style="text-align:center;text-decoration:underline;font-weight: bold;">(NTC)</div>
        <div class="col-3 noPadding">
          <svg height="35" width="35">
            <rect x="10" y="10" width="20" height="10" stroke="black" stroke-width="1" fill="#ff6347" />
          </svg> 
          <label class="m-0">{{'coverage breadth  >= 90% '}}</label>
        </div>
        <div class="col-3 noPadding">
          <svg height="35" width="35">
            <rect width="20" x="10" y="10" height="10" stroke="black" stroke-width="1" fill="#FFFF00" />
          </svg>
          <label class="m-0">{{'30%  <= cb  < 90%'}}</label>
        </div>
        <div class="col-3 noPadding">
          <svg height="35" width="35">
            <rect width="20" x="10" y="10" height="10" stroke="black" stroke-width="1" fill="#90EE90" />
          </svg>
          <label class="m-0">{{'10%  <= cb < 30%'}}</label>
        </div>
        <div class="col-3 noPadding">
          <svg height="35" width="35">
            <rect width="20" height="10" stroke="black" x="10" y="10" stroke-width="1" fill="#ADD8E6" />
          </svg>
          <label class="m-0">{{' coverage breadth < 10% '}}</label>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 legendBorderWithPadding parentDiv" style="height: 6.5em;" [hidden]="!showPlateView" *ngIf="val2 == 'Lineage classification'">
  
    <div class="col-12" style="font-weight: bold;" id="processingTableHeader">
      Legend
    </div>
    <div class="col-12 noPadding" >
      <div class="col-12 noPadding legendBorder childDiv">
        <div class="col-3 noPadding" style="width:30%">
          <svg height="35" width="35">
            <rect width="20" height="10" stroke="#006B96" x="10" y="10" stroke-width="1" fill="#ffffff" />
          </svg>
          <label class="m-0" style="font-size: 13px;">No data found</label>
        </div>
      
        <div class="col-3 noPadding" style="width:70%">
          <svg height="35" width="35">
            <rect width="20" height="10" stroke="#a9a9a9" x="10" y="10" stroke-width="3" fill="#ffffff" />
          </svg>
          <label class="m-0" style="font-size: 13px;">up to 3 PC mutants are found(T19065C,T22303G,G26144T)</label>
        </div>
        <div><label style="padding-left: 1%;font-size: 13px;">For individual lineage color please see pie chart legend</label></div>  
      </div>
    </div>
  </div>

  <div class="col-12 legendBorderWithPadding parentDiv"  
      [hidden]="!showPlateView" *ngIf="val2 == 'Batch QC Report'">
  
      <table aria-hidden="true" style="width: 100% ; border-color: black;">  
        <tr style="width: 100%">
          <td  style = "width: 25%" id="processingTableHeader">qc passed</td>
          <td  style= "width: 75%" id="processingTableHeader">qc failed</td>
        </tr>
        <tr>
          <td rowspan="2" style="text-align: center">{{qcPassed}} </td>
          <td style="text-align:center ;">        
                  
                    <tr>
                      <td style="text-align: center">read count</td>  
                      <td style="text-align: center">mean coverage/coverage breadth</td>
                    </tr>
                    <tr>
                      <td style="text-align: center">{{qcReadCount}}</td>
                      <td style="text-align: center">{{qcMergeCount}}</td>
                    </tr>
                  
          </td>

        
        </tr>

      </table>
    
  </div>


  <div class="col-12" 
      [hidden]="!showPlateView" *ngIf="val2 == 'Batch QC Report'">
      <p-table [value]="batchQCView" [scrollable]="true" (sortFunction)="customSort($event)" [customSort]="true" scrollHeight="250%">
          <ng-template  pTemplate="header">
              <tr>
                  <th id="processingTableHeader" 
                  pSortableColumn="barcode"  style="width: 40%"
                  >sample name
                  <p-sortIcon [field]="barcode"></p-sortIcon>

                </th>
                  <th id="processingTableHeader"    pSortableColumn="positionRowAscii" >plate position
                      <p-sortIcon [field]="positionRowAscii"></p-sortIcon>
                  </th>
                  <th id="processingTableHeader"  pSortableColumn="qcStatus">qc status
                      <p-sortIcon [field]="qcStatus"></p-sortIcon>
                  </th>
                  <th id="processingTableHeader" pSortableColumn="reason" style="width: 20%">qc failed criteria
                      <p-sortIcon [field]="reason"></p-sortIcon>
                  </th>
                  <th id="processingTableHeader" pSortableColumn="qcReviewdBy">reviewed by
                      <p-sortIcon [field]="qcReviewdBy"></p-sortIcon>

                  </th>
                  <th id="processingTableHeader" pSortableColumn="qcReviewedOn">reviewed on
                      <p-sortIcon [field]="qcReviewedOn"> </p-sortIcon>                   
                  </th>
              </tr>

          </ng-template>
          <ng-template pTemplate="body" let-batchQCView>
              <tr>
                  <td style="text-align: center; width: 40%">{{batchQCView.barcode}}</td>
                  <td style="text-align: center;">{{batchQCView.positionRowAscii}}</td>
                  <td style="text-align: center;">{{batchQCView.qcStatus}}</td>
                  <td style="text-align: center; width: 20%">{{batchQCView.reason}}</td>
                  <td style="text-align: center;">{{batchQCView.qcReviewdBy}}</td>
                  <td style="text-align: center;">{{batchQCView.qcReviewedOn}}</td>
              </tr>
          </ng-template>
      </p-table> 
  </div>



  <div class="col-12 noPadding" [hidden]="!showPlateView" *ngIf="val2 == 'Read Counts'" id="sampleScannerInterface">
    <div class="col-12">
      <div class="col-6">
        <label style="font-size: large;">Manual QC Review Mode</label>
        <p-inputSwitch [(ngModel)]="manualQCReviewMode" (onChange)="onManualQCReviewOff($event, mapOfQCReviewsForNumberReads, 'numberReads')"></p-inputSwitch>
      </div>
      <div class="col-6">
        <button pButton  id="uploadButton" label="Save QC Reviews" class="float-right"
            (click)="saveQCReviews('numberReads')" [disabled]="disableSaveQCForReadCount()">
          </button>
      </div> 
    </div>
    <div class="col-12" style="padding: 1%;">
      <table id="scanTable" aria-describedby="Conc View" class="table" style="width: 100%;">
        <thead>
          <tr class="row100 head">
            <th class="column100 column1" scope="col"></th>
            <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders; let k = index"
              [ngStyle]="getColHeaderStyle(k)">{{col}}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
            <td class="column100 column1" [ngStyle]="getRowHeaderStyle(i)">{{row}}</td>
            <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%"
              (click)="cellSelection(i, j)">
              <em *ngIf="!manualQCReviewMode && checkIfQCFailedForReadCount(i, j)" class="fa fa-warning position-absolute" style="font-size: 1.5em;">
              </em>

              <input *ngIf="manualQCReviewMode && sampleExistsAt(i,j)" [ngModel]="checkIfQCFailedForReadCount(i, j)" (change)="onCheckBoxValueChangeForReadCount($event, i, j)" type="checkbox" class="position-absolute"/>
              <input pTooltip="{{getToolTipForSamples(i,j)}}" [tooltipDisabled]="disableToolTipIf(i, j)" class="cellviewsold" pInputText type="text" name="sampleBarcode"
                [value]="getPrimaryAnalysisReadCount(i, j)"
                [style.background-color]="getReadCountCellBackgroundColor(i, j)" readonly />
            </td>
          </tr>
          <tr class="row100" >
            <td class="column100 column1"  colspan="12">Undetermined reads: {{getUnderminedReads()}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="col-12 noPadding" [hidden]="!showPlateView" *ngIf="val2 == 'Mean coverage/Coverage breadth'" id="sampleScannerInterface">
    <div class="col-12">
      <div class="col-6">
        <label style="font-size: large;">Manual QC Review Mode</label>
        <p-inputSwitch [(ngModel)]="manualQCReviewMode2" (onChange)="onManualQCReviewOff($event, mapOfQCReviewsForMetricsMerged, 'metricsMerged')"></p-inputSwitch>
      </div>
      <div class="col-6">
        <button pButton  id="uploadButton" label="Save QC Reviews" class="float-right"
            (click)="saveQCReviews('metricsMerged')" [disabled]="disableSaveQCForMetricsMerged()">
          </button>
      </div> 
    </div>
    <div class="col-12" style="padding: 1%;">
      <table id="scanTable" aria-describedby="Conc View" class="table" style="width: 100%;">
        <thead>
          <tr class="row100 head">
            <th class="column100 column1" scope="col"></th>
            <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders; let k = index"
              [ngStyle]="getColHeaderStyle(k)">{{col}}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
            <td class="column100 column1" [ngStyle]="getRowHeaderStyle(i)">{{row}}</td>
            <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%"
              (click)="cellSelection(i, j)">
          <table aria-hidden="true" class="boarders">
          <tr>
            <td>
              <em *ngIf="!manualQCReviewMode2 && checkIfQCFailedForMeanCoverage(i, j)" class="fa fa-warning position-absolute " style="font-size: 1.5em">
              </em>

              <input *ngIf="manualQCReviewMode2 && sampleExistsAt(i,j)" [ngModel]="checkIfQCFailedForMeanCoverage(i, j)" (change)="onCheckBoxValueChangeForMeanCoverage($event, i, j)" type="checkbox" class="position-absolute"/>
            <input pTooltip="{{getToolTipForSamples(i,j)}}" [tooltipDisabled]="disableToolTipIf(i, j)" class="cellviewsold-one" pInputText  type="text" name="sampleBarcode"
            [value]="getSecondaryAnalysisMeanCoveragevalue(i, j)" 
            [style.background-color]="getCellBackgroundColorOfMeanCoverage(i, j)" readonly /></td>
          </tr>
          <tr> 
            <td>
            <input pTooltip="{{getToolTipForSamples(i,j)}}" [tooltipDisabled]="disableToolTipIf(i, j)" class="cellviewsold-two" pInputText  type="text" name="sampleBarcode"
            [value]="getSecondaryAnalysisCoverageBreadth(i, j)" 
            [style.background-color]="getCellBackgroundColorOfMeanCoverage(i, j)" readonly /></td>
          </tr>
          </table>
          </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div *ngIf="val2 == 'Mean coverage/Coverage breadth'"><u><a href="javascript:void(0)" style="padding: 1%;"
    (click)="downloadHtmlFile()">{{htmlfileName}}</a></u>
  </div>
</div>


<div class="col-12 noPadding" [hidden]="!showPlateView" *ngIf="val2 == 'Lineage classification'" id="sampleScannerInterface">
  <div class="col-12" style="padding: 1%;">
    <table id="scanTable" aria-describedby="Conc View" class="table" style="width: 100%;">
      <thead>
        <tr class="row100 head">
          <th class="column100 column1" scope="col"></th>
          <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders; let k = index"
            [ngStyle]="getColHeaderStyle(k)">{{col}}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
          <td class="column100 column1" [ngStyle]="getRowHeaderStyle(i)">{{row}}</td>
          <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%">
        <table aria-hidden="true" class="boardersMutation" [style.border-color]="mutationRowSelection(i, j)" [style.border-width]="mutationRowSelectionBorderSolid(i, j)">
        <tr>
          <td>
          <input pTooltip="{{getToolTipForMutationData(i,j)}}" [tooltipDisabled]="disableToolTipIf(i, j)" class="cellviewsold-one" pInputText  type="text" name="sampleBarcode"
          [value]="getSecondaryAnalysisPangolianLeneageValue(i, j)" 
          [style.background-color]="getCellBackgroundColorOfLinageClassification(i, j)" 
          readonly /></td>
        </tr>
        <tr> 
          <td>
          <input  pTooltip="{{getToolTipForMutationData(i,j)}}" [tooltipDisabled]="disableToolTipIf(i, j)" class="cellviewsold-two" pInputText  type="text" name="sampleBarcode"
          [value]="getSecondaryAnalysisPangolianLeneageSnpValue(i, j)" 
          [style.background-color]="getCellBackgroundColorOfLinageClassification(i, j)" readonly /></td>
        </tr>
        </table>
        </td>
        </tr>
      </tbody>
    </table>
  </div> 
  <div id="downloadLink" >
    <div><label>Pangolin lineage file:</label>
      <u><a href="javascript:void(0)" (click)="downloadPangolianTextFile()">{{pangolianTextFileName}}</a></u>
    </div>
    <div><label>Variant files: {{variantFilesProcessed}}</label></div>
  </div>
  <div id="ngxchart">
    <div class='ngx-label'><label>Lineage Statistics:  </label></div>
    <ngx-charts-pie-chart
      [results]="pangoliandata"
      [legend]="true"
      [legendTitle]="'Legend'"
      [view]="[700,400]"
      [labels]="true" 
      [customColors]="customColors"
      >
    </ngx-charts-pie-chart>
  </div>
</div>
</div>

<div *ngIf="viewMode == 'MIDPLEX_PLATE_VIEW_MODE'">
  <div class="col-4">
    <p-radioButton name="redoGroup" value="Detail" label="Detail View" [(ngModel)]="val2" inputId="rd3">
    </p-radioButton>
  </div>
  <div class="col-4" *ngIf="this.selectedBatch.snpResultUploadDateTime">
    <p-radioButton name="redoGroup" value="SNPResults" label="SNP Results" [(ngModel)]="val2" inputId="rd3">
    </p-radioButton>
  </div>
  <div class="col-12 legendBorderWithPadding parentDiv" [hidden]="!showPlateView"  *ngIf="val2 === 'Detail'">
    <div class="col-12 font-weight-bold" id="processingTableHeader">
      Legend
    </div>
    <div class="col-12 noPadding">
      <div class="col-12 noPadding legendBorder childDiv">
        <div class="col-4 noPadding">
          <svg height="35" width="35">
            <circle cx="20" cy="20" r="10" stroke="black" stroke-width="3" fill="#f0cced" />
          </svg>
           <label class="m-0"> Sample </label> 
        </div>
        <div class="col-4 noPadding">
          <svg height="35" width="35">
            <circle cx="20" cy="20" r="10" stroke="black" stroke-width="3" fill="aqua" />
          </svg>
            <label class="m-0"> Positive Control</label> 
        </div>
        <div class="col-4 noPadding">
          <svg height="35" width="35">
            <circle cx="20" cy="20" r="10" stroke="black" stroke-width="3" fill="yellow" />
          </svg>
            <label class="m-0"> Negative Control </label>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 legendBorderWithPadding parentDiv" style="height: 10.5rem;"[hidden]="!showPlateView"  *ngIf="val2 === 'SNPResults'">
    <div class="col-12 font-weight-bold" id="processingTableHeader">
      Legend
    </div>
    <div class="col-12 noPadding">
      <div class="col-12 noPadding legendBorder childDiv">
        <div class="col-4" style="font-size: 98%;text-align: center;margin-top: 16px;">
          <table aria-hidden="true" style="border-color:#006b96">  
            <tr>
              <td> <tr>     <td>Valid marker of panel 1</td>  
                        </tr>
                        <tr>
                          <td>Valid marker panel total(Sex determination)</td>
                        </tr>
              </td>
            </tr>
          </table></div>
        <div class="col-4 noPadding" >
          <div class="col-8" style="padding: 0% 0% 0% 38%;height: 28px;" >
            <div class="col-3"> f </div> 
            <div class="col-1"> -  </div>
            <div class="col-4">Female</div>
          </div>
          <div class="col-8" style="padding: 0% 0% 0% 38%;height: 28px;" >
            <div class="col-3"> m </div> 
            <div class="col-1"> -  </div>
            <div class="col-4">Male</div>
          </div>
          <div class="col-8" style="padding: 0% 0% 0% 38%;height: 28px;">
            <div class="col-3"> c </div> 
            <div class="col-1"> -  </div>
            <div class="col-4">Conflicting</div>
          </div>
          <div class="col-8" style="padding: 0% 0% 0% 38%;height: 28px;">
            <div class="col-3"> u </div> 
            <div class="col-1"> -  </div>
            <div class="col-4">Undefined</div>
          </div>
        </div>
        <div class="col-4 noPadding" style="float: right; margin-top: 16px;">
          <svg height="35" width="35">
            <rect x="10" y="10" width="20" height="10" stroke="black" stroke-width="1" fill="#71ea71" />
          </svg>
            <label class="m-0"> >=</label><label class="m-0" style="padding-left: 2%;">SNP Profile Threshold of panel 1</label><br>
          <svg height="35" width="35">
            <rect x="10" y="10" width="20" height="10" stroke="black" stroke-width="1" fill="#f37070" />
          </svg> 
            <label class="m-0" style="padding-left: 2%;"><em> < </em></label><label class="m-0" style="padding-left: 2.4%;">SNP Profile Threshold of panel 1</label>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12" [hidden]="!showPlateView" *ngIf="val2 === 'SNPResults'">
      <div *ngFor="let quad of quadrantList">
        
        <div class="col-12" *ngIf="quadrantBatchMap.has(quad)">
          <label class="font-weight-bold" style="color:#006b96; font-size:125%">{{getBatchLabel(quad)}}</label>
          <table data-vertable="ver5" id="scanTable" aria-describedby="Plate Four Detail" class="table" style="width: 100%;">
            <thead>
              <tr class="row100 head">
                <th class="column100 column1" scope="col"></th>
                <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders">{{col}}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
                <td class="column100 column1" style="color: #006b96;font-weight: bold;">{{row}}</td>
                <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%">
              <table aria-hidden="true" class="boarders">
                <tr>
                  <td>
                    <input class="cellviewsold-one" pInputText type="text" pTooltip="{{getToolTipForSnp(i,j,quad)}}"  name="sampleBarcode"
                    [value]="getSampleAtWrapperforSNp(i, j, quad)"  [ngStyle]="getMidplexSNPProfileSampleBoxColor1(i, j, quad)"
                     readonly /></td>
                  </tr>
                  <tr> 
                    <td>
                      <input class="cellviewsold-two" pInputText type="text" pTooltip="{{getToolTipForSnp(i,j,quad)}}" name="sampleBarcode"
                      [value]="getSampleAtWrapperforSNpTotalPanel(i, j, quad)" [ngStyle]="getMidplexSNPProfileSampleBoxColor1(i, j, quad)"
                     readonly /></td>
                  </tr>
                </table>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>



  <div class="col-12" *ngIf="selectedBatch.wellType ==='WELL384' && showPlateView && val2 == 'Detail' ">
    <div *ngFor="let quad of quadrantList">
      
      <div class="col-12" *ngIf="quadrantBatchMap.has(quad)">
        <label class="font-weight-bold" style="color:#006b96; font-size:125%">{{getBatchLabel(quad)}}</label>
        <table data-vertable="ver5" id="scanTable" aria-describedby="Plate Four Detail" class="table" style="width: 100%;">
          <thead>
            <tr class="row100 head">
              <th class="column100 column1" scope="col"></th>
              <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders">{{col}}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
              <td class="column100 column1" style="color: #006b96;font-weight: bold;">{{row}}</td>
              <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%">
                <input class="cellviewsold" pInputText type="text" name="sampleBarcode" dir="rtl"
                  [value]="getSampleAtWrapper(i, j, quad).barcode"
                  [ngStyle]="getMidplexSampleBoxColor(getSampleAtWrapper(i, j, quad).barcode)" readonly />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="col-12" *ngIf="selectedBatch.wellType ==='WELL96' && showPlateView && val2 === 'Detail' ">
    <div class="col-12">
      <table data-vertable="ver5" id="scanTable" aria-describedby="Plate Four Detail" class="table" style="width: 100%;">
        <thead>
          <tr class="row100 head">
            <th class="column100 column1" scope="col"></th>
            <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders">{{col}}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
            <td class="column100 column1 font-weight-bold" style="color: #006b96;">{{row}}</td>
            <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%">
              <input class="cellviewsold" pInputText type="text" name="sampleBarcode" dir="rtl"
                [value]="getSampleAt(i, j, plateMap).barcode"
                [ngStyle]="getMidplexSampleBoxColor(getSampleAt(i, j, plateMap).barcode)" readonly />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>

<!-- USELESS CODE BELOW (EXCEPT FOR REFERENCING) -->
<div *ngIf="viewMode == 'APG_PLATE'">
<div class="col-12" *ngIf="selectedBatch.wellType ==='WELL384'">
  <div class="col-4">

    <p-radioButton name="redoGroup" value="384" label="384 Overview" [(ngModel)]="val2" inputId="rd1">
    </p-radioButton>
  </div>
  <div class="col-4">


    <p-radioButton name="redoGroup" value="96" label="4*96 Overview" [(ngModel)]="val2" inputId="rd2">
    </p-radioButton>
  </div>
  <div class="col-4">


    <p-radioButton name="redoGroup" value="96 Detail" label="4*96 Detail View" [(ngModel)]="val2" inputId="rd3">
    </p-radioButton>
  </div>
  <p-fieldset legend="Legend & PCR Output Upload and Result Report Download" toggleable="true"
    *ngIf="val2 === '384' || val2 === '96'">
    <div class="col-6 legendBorderWithPadding parentDiv" [hidden]="!showPlateView">
      <div class="col-12" style="font-weight: bold;" id="processingTableHeader">
        Legend
      </div>
      <div class="col-12 noPadding">
        <div class="col-4 noPadding legendBorder384">
          <div class="col-12 noPadding">
            <div class="col-9 legend">
              Sample :
            </div>
            <div class="col-3 noPadding">
              <svg height="35" width="35">
                <circle cx="20" cy="20" r="10" stroke="black" stroke-width="3" fill="violet" />
              </svg>
            </div>
          </div>
          <div class="col-12 noPadding">
            <div class="col-9 legend">
              POS_EX :
            </div>
            <div class="col-3 noPadding">
              <svg height="35" width="35">
                <circle cx="20" cy="20" r="10" stroke="black" stroke-width="3" fill="aqua" />
              </svg>
            </div>
          </div>
          <div class="col-12 noPadding">
            <div class="col-9 legend">
              NTC_EX :
            </div>
            <div class="col-3 noPadding">
              <svg height="35" width="35">
                <circle cx="20" cy="20" r="10" stroke="black" stroke-width="3" fill="yellow" />
              </svg>
            </div>
          </div>
        </div>
        <div class="col-4 noPadding legendBorder384">
          <div class="col-12 noPadding">
            <div class="col-9 legend">
              Sample OK :
            </div>
            <div class="col-3 noPadding">
              <svg height="35" width="35">
                <circle cx="20" cy="20" r="10" stroke="green" stroke-width="5" fill="green" />
              </svg>
            </div>
          </div>
          <div class="col-12 noPadding">
            <div class="col-9 legend">
              Sample Positive :
            </div>
            <div class="col-3 noPadding">
              <svg height="35" width="35">
                <circle cx="20" cy="20" r="10" stroke="red" stroke-width="5" fill="red" />
              </svg>
            </div>
          </div>
          <div class="col-12 noPadding">
            <div class="col-9 legend">
              Sample Ambiguous :
            </div>
            <div class="col-3 noPadding">
              <svg height="35" width="35">
                <circle cx="20" cy="20" r="10" stroke="#FFA500" stroke-width="5" fill="#FFA500" />
              </svg>
            </div>
          </div>
          <div class="col-12 noPadding">
            <div class="col-9 legend">
              Sample Invalid :
            </div>
            <div class="col-3 noPadding">
              <svg height="35" width="35">
                <circle cx="20" cy="20" r="10" stroke="#b3afa4" stroke-width="5" fill="#b3afa4" />
              </svg>
            </div>
          </div>
        </div>
        <div class="col-4 noPadding legendBorder384">
          <div class="col-12 noPadding">
            <div class="col-9 legend">
              Positive Control OK :
            </div>
            <div class="col-3 noPadding">
              <svg height="40" width="40">
                <circle cx="20" cy="20" r="10" stroke="green" stroke-width="5" fill="aqua" />
              </svg>
            </div>
          </div>
          <div class="col-12 noPadding">
            <div class="col-9 legend">
              Negative Control OK:
            </div>
            <div class="col-3 noPadding">
              <svg height="40" width="40">
                <circle cx="20" cy="20" r="10" stroke="green" stroke-width="5" fill="yellow" />
              </svg>
            </div>
          </div>
          <div class="col-12 noPadding">
            <div class="col-9 legend" style="padding-top: 0%; padding-bottom: 0%;">
              Control Failed :
            </div>
            <div class="col-3 noPadding" style="padding-left: 6%;">
              <svg height="20" width="20">
                <line x1="0" y1="20" x2="20" y2="0" stroke="red" stroke-width="4" />
                <line x1="0" y1="0" x2="20" y2="20" stroke="red" stroke-width="4" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-6 pcrOutPutResult parentDiv" [hidden]="!showPlateView" [ngClass]="{ 'disableTD': !(selectedBatch.statusOfTheBatch == 'ANALYSIS_STARTED' || selectedBatch.statusOfTheBatch == 'ANALYSIS_DONE'
      || selectedBatch.statusOfTheBatch == 'DATA_READY' || selectedBatch.statusOfTheBatch == 'COMPLETED')}">
      <div class="col-12" style="font-weight: bold;" id="processingTableHeader">
        PCR Output Upload and Result Report Download
      </div>
      <div class="col-8 border border-info uploadclass">
        <div class="col-12 commentDiv p-0">
          <input pInputText class="form-control" name="resultUpload" type="file" multiple="true"
            accept=".txt,.ixo,.xlsx,.pcrd,.xml,.csv" (change)="onResultFileChange($event)" id="resultFileChooser"
            placeholder="Upload Results" [disabled]="!(selectedBatch.statusOfTheBatch == 'ANALYSIS_STARTED'  || selectedBatch.statusOfTheBatch == 'ANALYSIS_DONE'
            || selectedBatch.statusOfTheBatch == 'DATA_READY' || selectedBatch.statusOfTheBatch == 'COMPLETED')" />
        </div>
        <div class="col-12 text-center" id="uploadResultButtonDiv" style="margin-top: 2%;">
          <button pButton icon="fa fa-upload" type="submit" id="uploadButton" label="Upload"
            (click)="resultUploadsubmit()" [disabled]="!(selectedBatch.statusOfTheBatch == 'ANALYSIS_STARTED'  || selectedBatch.statusOfTheBatch == 'ANALYSIS_DONE'
            || selectedBatch.statusOfTheBatch == 'DATA_READY' || selectedBatch.statusOfTheBatch == 'COMPLETED')">
          </button>
        </div>
      </div>
      <div class="col-4 text-center border border-info uploadclass">
        <button class="mt-3" pButton icon="fa fa-download" type="button" label="Result Report"
          (click)="resultReportDownload(selectedBatch.batchID)" [disabled]="!allChannelsUpdatedForBatch()"></button>
      </div>
    </div>
  </p-fieldset>


  <div class="col-12 legendBorderWithPadding" [hidden]="!showPlateView" *ngIf="val2 === '384' || val2 === '96'"
    [ngClass]="{ 'disableTD': !(selectedBatch.statusOfTheBatch == 'ANALYSIS_STARTED'|| selectedBatch.statusOfTheBatch == 'ANALYSIS_DONE')}"
    style="padding: 0%;">
    <div class="col-10" style=" font-size: small;">
      <div class="col-3" *ngIf="selectedBatch.mergedBatches[0]">
        <div class="pb-0" [ngStyle]="getBoxColour(selectedBatch.mergedBatches[0]?.quadrant)"
          [style.background-color]="getBoxColour1(0)" [style.color]="getFontColorFor384(0)"
          style="outline-style: solid;padding: 3%;">
          {{selectedBatch.mergedBatches[0]?.batchId}}
          <a href="javascript:void(0)" [style.color]="getLinkColorFor384(0)"
            *ngIf="checkIfFinalResultIsRedo(selectedBatch.mergedBatches[0].finalResult)" class="float-right"
            (click)="showRedoReasonPopup(0)">Why?</a>
          <p-dropdown id="ResultStatus" [options]="getFinalStatusList(selectedBatch.mergedBatches[0])"
            [disabled]="!proceedToCompleteAnalysis() || selectedBatch.mergedBatches[0]?.redone"
            placeholder="Select Result" name="groupname" [(ngModel)]="selectedBatch.mergedBatches[0].finalResult"
            [style]="{'width':'100%','border':'1px solid'}" (onChange)="verifyAllSampleChecksResolved(plateMap,false)">
          </p-dropdown>
          <label class="m-0"><small>{{getRedoReason(selectedBatch.mergedBatches[0])}}</small></label>
        </div>
      </div>
      <div class="col-3" *ngIf="selectedBatch.mergedBatches[1]">
        <div class="pb-0" [ngStyle]="getBoxColour(selectedBatch.mergedBatches[1]?.quadrant)"
          [style.background-color]="getBoxColour1(1)" [style.color]="getFontColorFor384(1)"
          style="outline-style: solid;padding: 3%;">
          {{selectedBatch.mergedBatches[1]?.batchId}}
          <a href="javascript:void(0)" [style.color]="getLinkColorFor384(1)"
            *ngIf="checkIfFinalResultIsRedo(selectedBatch.mergedBatches[1].finalResult)" class="float-right"
            (click)="showRedoReasonPopup(1)">Why?</a>
          <p-dropdown id="ResultStatus" [options]="getFinalStatusList(selectedBatch.mergedBatches[1])"
            [disabled]="!proceedToCompleteAnalysis() || selectedBatch.mergedBatches[1]?.redone"
            placeholder="Select Result" name="groupname" [(ngModel)]="selectedBatch.mergedBatches[1].finalResult"
            [style]="{'width':'100%','border':'1px solid'}" (onChange)="verifyAllSampleChecksResolved(plateMap,false)">
          </p-dropdown>
          <label class="m-0"><small>{{getRedoReason(selectedBatch.mergedBatches[1])}}</small></label>
        </div>
      </div>
      <div class="col-3" *ngIf="selectedBatch.mergedBatches[2]">
        <div class="pb-0" [ngStyle]="getBoxColour(selectedBatch.mergedBatches[2]?.quadrant)"
          [style.background-color]="getBoxColour1(2)" [style.color]="getFontColorFor384(2)"
          style="outline-style: solid;padding: 3%;">
          {{selectedBatch.mergedBatches[2]?.batchId}}
          <a href="javascript:void(0)" [style.color]="getLinkColorFor384(2)"
            *ngIf="checkIfFinalResultIsRedo(selectedBatch.mergedBatches[2].finalResult)" class="float-right"
            (click)="showRedoReasonPopup(2)">Why?</a>
          <p-dropdown id="ResultStatus" [options]="getFinalStatusList(selectedBatch.mergedBatches[2])"
            [disabled]="!proceedToCompleteAnalysis() || selectedBatch.mergedBatches[2]?.redone"
            placeholder="Select Result" name="groupname" [(ngModel)]="selectedBatch.mergedBatches[2].finalResult"
            [style]="{'width':'100%','border':'1px solid'}" (onChange)="verifyAllSampleChecksResolved(plateMap,false)">
          </p-dropdown>
          <label class="m-0"><small>{{getRedoReason(selectedBatch.mergedBatches[2])}}</small></label>
        </div>
      </div>
      <div class="col-3" *ngIf="selectedBatch.mergedBatches[3]">
        <div class="pb-0" [ngStyle]="getBoxColour(selectedBatch.mergedBatches[3]?.quadrant)"
          [style.background-color]="getBoxColour1(3)" [style.color]="getFontColorFor384(3)"
          style="outline-style: solid;padding: 3%;">
          {{selectedBatch.mergedBatches[3]?.batchId}}
          <a href="javascript:void(0)" [style.color]="getLinkColorFor384(3)"
            *ngIf="checkIfFinalResultIsRedo(selectedBatch.mergedBatches[3].finalResult)" class="float-right"
            (click)="showRedoReasonPopup(3)">Why?</a>
          <p-dropdown id="ResultStatus" [options]="getFinalStatusList(selectedBatch.mergedBatches[3])"
            [disabled]="!proceedToCompleteAnalysis() || selectedBatch.mergedBatches[3]?.redone"
            placeholder="Select Result" name="groupname" [(ngModel)]="selectedBatch.mergedBatches[3].finalResult"
            [style]="{'width':'100%','border':'1px solid'}" (onChange)="verifyAllSampleChecksResolved(plateMap,false)">
          </p-dropdown>
          <label class="m-0"><small>{{getRedoReason(selectedBatch.mergedBatches[3])}}</small></label>
        </div>
      </div>
    </div>
    <div class="col-2 pb-0">
      <div>
        <button pButton class="completeAnalysis384" type="button" label="Complete Analysis"
          (click)="confirmCompleteAnalysis()" [disabled]="!proceedToCompleteAnalysis()"></button>
      </div>
      <div class="text-right" *ngIf="selectedBatch.analysisVerificationPUID">
        <label class="m-0">Verified by {{selectedBatch.analysisVerificationPUID}}</label>
      </div>
    </div>
  </div>
  <div class="col-12 noPadding" style="padding-top: 1%" [hidden]="!showPlateView" *ngIf="val2 === '384'">
    <table data-vertable="ver5" id="scanTable" class="table" aria-describedby="384 Overview" style="width: 100%;">
      <thead>
        <tr class="row100 head">
          <th scope="col" class="column100 column1"></th>
          <th scope="col" class="column100 column2" *ngFor="let col of columnHeaders384">{{col}}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="row100" *ngFor="let row of rowHeaders384; let i = index;">
          <td class="column100 column1" style="color: #006b96;font-weight: bold; padding-bottom: 0%; padding-top: 1%;">
            {{row}}</td>
          <td class="column100 column2" *ngFor="let col of columnHeaders384; let j = index" style="padding:0%">
            {{getColor(i,j,plateMap)}}
            <button style="border: 1px solid white; background-color: transparent; padding: 0%;"
              (click)="showSamplePopUp(i, j, plateMap)">
              <svg height="40" width="40">
                <rect width="100%" height="100%" stroke-width="7" attr.stroke="{{backGroundColor}}" fill="white" />
                <circle cx="20" cy="20" r="10" attr.stroke="{{circleBorder}}" attr.stroke-width="{{circleStroke}}"
                  attr.fill="{{color}}" />
                <line x1="0" y1="40" x2="40" y2="0" attr.stroke="{{crossColor}}" attr.stroke-width="{{crossWidth}}" />
                <line x1="0" y1="0" x2="40" y2="40" attr.stroke="{{crossColor}}" attr.stroke-width="{{crossWidth}}" />
              </svg>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="col-6" [hidden]="!showPlateView" *ngIf="val2 === '96' && plateOne !== undefined">

    <label style="color:#5858fa ; font-weight:bold; font-size:125%">{{plateOne}}</label>

    <table data-vertable="ver5" id="scanTable" aria-describedby="Plate One" class="table" style="width: 100%;">

      <thead>
        <tr class="row100 head">
          <th class="column100 column1" scope="col"></th>
          <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders">{{col}}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
          <td class="column100 column1" style="color: #006b96;font-weight: bold;">{{row}}</td>
          <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%">
            {{getColor(i,j,sampleBatch1Map)}}
            <button style="border: 1px solid white; background-color: transparent; padding: 0%;"
              (click)="showSamplePopUp(i, j, sampleBatch1Map)">
              <svg height="48" width="40" viewBox="0 0 40 48">
                <circle cx="20" cy="20" r="10" attr.stroke="{{circleBorder}}" attr.stroke-width="{{circleStroke}}"
                  attr.fill="{{color}}" />
                <line x1="0" y1="40" x2="40" y2="0" attr.stroke="{{crossColor}}" attr.stroke-width="{{crossWidth}}" />
                <line x1="0" y1="0" x2="40" y2="40" attr.stroke="{{crossColor}}" attr.stroke-width="{{crossWidth}}" />
              </svg>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-6" [hidden]="!showPlateView" *ngIf="val2 === '96'  && plateTwo !== undefined">
    <label style="color:#ff9000 ; font-weight:bold; font-size:125%">{{plateTwo}}</label>
    <table data-vertable="ver5" id="scanTable" class="table" aria-describedby="Plate Two" style="width: 100%;">
      <thead>
        <tr class="row100 head">
          <th class="column100 column1" scope="col"></th>
          <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders">{{col}}</th>
        </tr>
      </thead>
      <tbody>

        <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
          <td class="column100 column1" style="color: #006b96;font-weight: bold;">{{row}}</td>
          <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%">
            {{getColor(i,j,sampleBatch2Map)}}
            <button style="border: 1px solid white; background-color: transparent; padding: 0%;"
              (click)="showSamplePopUp(i, j, sampleBatch2Map)">
              <svg height="48" width="40" viewBox="0 0 40 48">
                <circle cx="20" cy="20" r="10" attr.stroke="{{circleBorder}}" attr.stroke-width="{{circleStroke}}"
                  attr.fill="{{color}}" />
                <line x1="0" y1="40" x2="40" y2="0" attr.stroke="{{crossColor}}" attr.stroke-width="{{crossWidth}}" />
                <line x1="0" y1="0" x2="40" y2="40" attr.stroke="{{crossColor}}" attr.stroke-width="{{crossWidth}}" />
              </svg>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-6" [hidden]="!showPlateView" *ngIf="val2 === '96'  && plateThree !== undefined">
    <label style="color:#39ff14 ; font-weight:bold; font-size:125%">{{plateThree}}</label>
    <table data-vertable="ver5" id="scanTable" class="table" aria-describedby="Plate Three" style="width: 100%;">
      <thead>
        <tr class="row100 head">
          <th class="column100 column1" scope="col"></th>
          <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders">{{col}}</th>
        </tr>
      </thead>
      <tbody>

        <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
          <td class="column100 column1" style="color: #006b96;font-weight: bold;">{{row}}</td>
          <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%">
            {{getColor(i,j,sampleBatch3Map)}}
            <button style="border: 1px solid white; background-color: transparent; padding: 0%;"
              (click)="showSamplePopUp(i, j, sampleBatch3Map)">
              <svg height="48" width="40" viewBox="0 0 40 48">
                <circle cx="20" cy="20" r="10" attr.stroke="{{circleBorder}}" attr.stroke-width="{{circleStroke}}"
                  attr.fill="{{color}}" />
                <line x1="0" y1="40" x2="40" y2="0" attr.stroke="{{crossColor}}" attr.stroke-width="{{crossWidth}}" />
                <line x1="0" y1="0" x2="40" y2="40" attr.stroke="{{crossColor}}" attr.stroke-width="{{crossWidth}}" />
              </svg>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-6" [hidden]="!showPlateView" *ngIf="val2 === '96'  && plateFour !== undefined">
    <label style="color:#886a08 ; font-weight:bold; font-size:125%">{{plateFour}}</label>
    <table data-vertable="ver5" id="scanTable" class="table" aria-describedby="Plate Four" style="width: 100%;">
      <thead>
        <tr class="row100 head">
          <th class="column100 column1" scope="col"></th>
          <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders">{{col}}</th>
        </tr>
      </thead>
      <tbody>

        <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
          <td class="column100 column1" style="color: #006b96;font-weight: bold;">{{row}}</td>
          <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%">
            {{getColor(i,j,sampleBatch4Map)}}
            <button style="border: 1px solid white; background-color: transparent; padding: 0%;"
              (click)="showSamplePopUp(i, j, sampleBatch4Map)">
              <svg height="48" width="40" viewBox="0 0 40 48">
                <circle cx="20" cy="20" r="10" attr.stroke="{{circleBorder}}" attr.stroke-width="{{circleStroke}}"
                  attr.fill="{{color}}" />
                <line x1="0" y1="40" x2="40" y2="0" attr.stroke="{{crossColor}}" attr.stroke-width="{{crossWidth}}" />
                <line x1="0" y1="0" x2="40" y2="40" attr.stroke="{{crossColor}}" attr.stroke-width="{{crossWidth}}" />
              </svg>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-12" [hidden]="!showPlateView" *ngIf="val2 === '96 Detail'  && plateOne !== undefined">
    <label style="color:#5858fa ; font-weight:bold; font-size:125%">{{plateOne}}</label>

    <table class="showSenderTable" data-vertable="ver5" id="scanTable" aria-describedby="Detail view"
      style="width: 100%;">
      <tbody>
        <tr>
          <th class="col-2" id="subSendersView" [ngStyle]="assignRandomLightColour(k,sub)"
            *ngFor="let sub of subSenderForPlateOne;let k = index">{{sub}}</th>
        </tr>
      </tbody>
    </table>

    <table data-vertable="ver5" id="scanTable" class="table" aria-describedby="Plate One Detail" style="width: 100%;">
      <thead>
        <tr class="row100 head">
          <th class="column100 column1" scope="col"></th>
          <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders">{{col}}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
          <td class="column100 column1" style="color: #006b96;font-weight: bold;">{{row}}</td>
          <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%">
            <input class="cellviewsold" pInputText type="text" name="sampleBarcode"
              [value]="getSampleAt(i, j, sampleBatch1Map).barcode"
              [ngStyle]="getSampleColorByUnboxedSender(getSampleAt(i, j, sampleBatch1Map).unboxedSender)" readonly />
          </td>
          <td>
            {{rowHeaders96Odd[i]}}
          </td>
        </tr>
        <tr>
          <td></td>
          <td *ngFor="let col of columnHeaders; let j = index" style="padding-left: 3%">
            {{columnHeaders96Odd[j]}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-12" [hidden]="!showPlateView" *ngIf="val2 === '96 Detail'  && plateTwo !== undefined">
    <label style="color:#ff9000 ; font-weight:bold ; font-size:125%">{{plateTwo}}</label>
    <table class="showSenderTable" data-vertable="ver5" id="scanTable" aria-describedby="Detail view"
      style="width: 100%;">
      <tbody>
        <tr>
          <th class="col-2" id="subSendersView" [ngStyle]="assignRandomLightColour(k,sub)"
            *ngFor="let sub of subSenderForPlateTwo;let k = index">{{sub}}</th>
        </tr>
      </tbody>
    </table>
    <table data-vertable="ver5" id="scanTable" aria-describedby="Plate Two Detail" class="table" style="width: 100%;">
      <thead>
        <tr class="row100 head">
          <th class="column100 column1" scope="col"></th>
          <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders">{{col}}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
          <td class="column100 column1" style="color: #006b96;font-weight: bold;">{{row}}</td>
          <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%">
            <input class="cellviewsold" pInputText type="text" name="sampleBarcode"
              [value]="getSampleAt(i, j, sampleBatch2Map).barcode"
              [ngStyle]="getSampleColorByUnboxedSender(getSampleAt(i, j, sampleBatch2Map).unboxedSender)" readonly />
          </td>
          <td>
            {{rowHeaders96Even[i]}}
          </td>
        </tr>
        <tr>
          <td></td>
          <td *ngFor="let col of columnHeaders; let j = index" style="padding-left: 3%">
            {{columnHeaders96Odd[j]}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-12" [hidden]="!showPlateView" *ngIf="val2 === '96 Detail'  && plateThree !== undefined">
    <label style="color:#39ff14 ; font-weight:bold; font-size:125%">{{plateThree}}</label>

    <table class="showSenderTable" data-vertable="ver5" id="scanTable" aria-describedby="Detail view"
      style="width: 100%;">
      <tbody>
        <tr>
          <th class="col-2" id="subSendersView" [ngStyle]="assignRandomLightColour(k,sub)"
            *ngFor="let sub of subSenderForPlateThree;let k = index">{{sub}}</th>
        </tr>
      </tbody>
    </table>

    <table data-vertable="ver5" id="scanTable" aria-describedby="Plate Three Detail" class="table" style="width: 100%;">
      <thead>
        <tr class="row100 head">
          <th class="column100 column1" scope="col"></th>
          <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders">{{col}}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
          <td class="column100 column1" style="color: #006b96;font-weight: bold;">{{row}}</td>
          <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%">
            <input class="cellviewsold" pInputText type="text" name="sampleBarcode"
              [value]="getSampleAt(i, j, sampleBatch3Map).barcode"
              [ngStyle]="getSampleColorByUnboxedSender(getSampleAt(i, j, sampleBatch3Map).unboxedSender)" readonly />
          </td>
          <td>
            {{rowHeaders96Odd[i]}}
          </td>
        </tr>
        <tr>
          <td></td>
          <td *ngFor="let col of columnHeaders; let j = index" style="padding-left: 3%">
            {{columnHeaders96Even[j]}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-12" [hidden]="!showPlateView" *ngIf="val2 === '96 Detail'  && plateFour !== undefined">
    <label style="color:#886a08 ; font-weight:bold; font-size:125%">{{plateFour}}</label>
    <table class="showSenderTable" data-vertable="ver5" id="scanTable" aria-describedby="Detail view"
      style="width: 100%;">
      <tbody>
        <tr>
          <th class="col-2" id="subSendersView" [ngStyle]="assignRandomLightColour(k,sub)"
            *ngFor="let sub of subSenderForPlateFour;let k = index">{{sub}}</th>
        </tr>
      </tbody>
    </table>
    <table data-vertable="ver5" id="scanTable" aria-describedby="Plate Four Detail" class="table" style="width: 100%;">
      <thead>
        <tr class="row100 head">
          <th class="column100 column1" scope="col"></th>
          <th class="column100 column2" scope="col" *ngFor="let col of columnHeaders">{{col}}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
          <td class="column100 column1" style="color: #006b96;font-weight: bold;">{{row}}</td>
          <td class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%">
            <input class="cellviewsold" pInputText type="text" name="sampleBarcode"
              [value]="getSampleAt(i, j, sampleBatch4Map).barcode"
              [ngStyle]="getSampleColorByUnboxedSender(getSampleAt(i, j, sampleBatch4Map).unboxedSender)" readonly />
          </td>
          <td>
            {{rowHeaders96Even[i]}}
          </td>
        </tr>
        <tr>
          <td></td>
          <td *ngFor="let col of columnHeaders; let j = index" style="padding-left: 3%">
            {{columnHeaders96Even[j]}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<p-dialog header="Analysis Details" [(visible)]="samplePopVisible" [modal]="true" [contentStyle]="{'max-height':'70vh'}"
  [blockScroll]="true" >
  <div class="col-12 p-0 pt-2 pb-2">
    <div class="col-1 p-0">
      <button pButton icon="fa fa-chevron-left" [disabled]="isLeftClickDirectionDisabled()"
        (click)="onLeftDirectionClick()"></button>
    </div>
    <div class="col-10 p-0 border-info batchLabel text-center font-weight-bold">
      <label class="labelText">{{batchHeaders[headerIndex]}}</label>
    </div>
    <div class="col-1 p-0">
      <button pButton icon="fa fa-chevron-right" [disabled]="isRightDirectionClickDisabled()"
        (click)="onRightDirectionClick()"></button>
    </div>
  </div>
  <div *ngIf="batchHeaders[headerIndex] == 'Current'">
    <div class="ui-inputgroup" id="inputClass">
      <button pButton class="theme-button noHover labelButton" type="button" label="Position"></button>
      <input pInputText type="text" name="Position" [(ngModel)]="samplePosition" readonly />
    </div>
    <div class="ui-inputgroup" id="inputClass">
      <button pButton class="theme-button noHover labelButton" type="button" label="Barcode"></button>
      <input pInputText type="text" name="Barcode" [(ngModel)]="selectedSample.barcode" readonly />
    </div>
    <div class="ui-inputgroup" id="inputClass">
      <button pButton class="theme-button noHover labelButton" type="button" label="Analysis"></button>
      <input pInputText type="text" name="Analysis" [(ngModel)]="sampleType" readonly />
    </div>

    <div *ngFor="let resultGroup of selectedSample.results">
      <div *ngIf="isResultGroup">
        <div class="col-12 cpValueTable">
          <div class="col-12 font-weight-bold" id="processingTableHeader">
            {{resultGroup.testingType}}
          </div>
          <p-table [style]="{'width':'384px'}" [value]="selectedSample.channels">
            <ng-template pTemplate="header">
              <tr>
                <th scope="col">Genes</th>
                <th scope="col">Cp</th>
                <th scope="col">Result</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-channel>
              <tr *ngIf="getChannelsdata(resultGroup.testingType).indexOf(channel.gene) != -1"
                style="overflow-wrap: break-word">
                <td [ngClass]="{'font-weight-bold': isChannelDominant(channel.gene)}">
                  {{channel.gene == 'Empty' ? '' : channel.gene}}</td>
                <td>{{channel.cpValue | number:'1.0-2'}}</td>
                <td *ngIf="channel.resultUploaded">
                  <p-dropdown [options]="getResultValues(channel.originalGeneResult)" [(ngModel)]="channel.geneResult"
                    [disabled]="disablePopUpUse()">
                  </p-dropdown>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr>
                <td colspan="2">
                  Result
                </td>
                <td>
                  <p-dropdown *ngIf="allChannelsUpdated(selectedSample)" [style]="{'width': '114px'}"
                    [options]="resultGroupControlResultOptions" [(ngModel)]="resultGroup.sampleResult"
                    [disabled]="disablePopUpUse()">
                  </p-dropdown>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
    <div *ngIf="!isResultGroup">
      <div class="col-12 cpValueTable">
        <div class="col-12 font-weight-bold" id="processingTableHeader">
          PCR Results
        </div>
        <p-table [style]="{'width':'384px'}" [value]="selectedSample.channels">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">Genes</th>
              <th scope="col">Cp</th>
              <th scope="col">Result</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-channel>
            <tr style="overflow-wrap: break-word">
              <td [ngClass]="{'font-weight-bold': isChannelDominant(channel.gene)}">{{channel.gene == 'Empty' ? '' :
                channel.gene}}</td>
              <td>{{channel.cpValue | number:'1.0-2'}}</td>
              <td>{{channel.resultUploaded ? getChannelResult(selectedSample, channel) : ''}}</td>

            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td colspan="2">
                Result
              </td>
              <td>
                <p-dropdown *ngIf="allChannelsUpdated(selectedSample)" [style]="{'width': '114px'}"
                  [options]="getResultOptions(selectedSample)" [(ngModel)]="selectedSample.result"
                  [disabled]="disablePopUpUse()">
                </p-dropdown>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <div *ngIf="batchHeaders[headerIndex] != 'Current'">
    <app-apg-sample-result-view *ngFor="let r of reset"
      [sampleHistory]="getHistoryForCurrentBatch(batchHeaders[headerIndex])" [sampleBarcode]="selectedSample.barcode"
      [sampleType]="sampleType"></app-apg-sample-result-view>
  </div>

  <div class="col-12 p-0"
    *ngIf="selectedSample.contaminationType && selectedSample.contaminationType != 'No Contamination' && selectedSample.contaminationType != 'No Swab'">
    <label class="warningText">{{getContaminationString(selectedSample)}}</label>
  </div>
  <div class="col-12 p-0 ui-inputgroup" id="inputClass">
    <button pButton class="theme-button noHover labelButton" type="button" label="Comments"></button>
    <textarea type="text" name="comment" [(ngModel)]="selectedSample.comments" [disabled]="disablePopUpUse()"
      placeholder="Enter comment here"></textarea>
  </div>
  <div *ngIf="!controlArray.includes(selectedSample.barcode)" class="p-0" id="inputClass">
    <p-checkbox binary="true" labelStyleClass="mb-0" [(ngModel)]="selectedSample.singleSampleRedo"
      label="Redo This Sample" [disabled]="disablePopUpUse()">
    </p-checkbox>
  </div>
  <p-footer>
    <button pButton label="Done" (click)="saveSampleDataDuringAnalysis()" [disabled]="disablePopUpUse()"></button>
  </p-footer>
</p-dialog>

<p-dialog header="Select Redo Reason" [(visible)]="redoReasonsPopup" [modal]="true" [dismissableMask]="true">
  <div *ngFor="let reason of redoReasons">
    <p-radioButton name="redoGroup" value="{{reason.value}}" label="{{reason.label}}" [(ngModel)]="selectedRedoReason">
    </p-radioButton>
  </div>

  <div *ngIf="selectedRedoReason == 'Other'">
    <input pInputText type="text" style="margin-top:3%" size="40" placeholder="Enter Redo Reason"
      [(ngModel)]="enteredRedoReason" />
  </div>
  <p-footer>
    <button pButton type="button" label="Done" [disabled]="redoButtonDisabledIf()" (click)="setRedoReason()"></button>
  </p-footer>
</p-dialog>

<p-dialog header="Sample Result Change Verification" [(visible)]="showAnalysisDialog" [modal]="true" 
  baseZIndex="100000" [dismissableMask]="true" (onHide)="clearVerificationPUID()">
  <div class="col-12 p-0">
    <p-table [style]="{'width':'1000px'}" [value]="changedSampleList" [columns]="columnList" dataKey="barcode"
      [scrollable]="true" scrollHeight="450px">
      <ng-template pTemplate="header" let-columns>
        <tr style="overflow-wrap: break-word">
          <th scope="col" *ngFor="let col of columns" [attr.colspan]="col.colspan">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr style="overflow-wrap: break-word">
          <td *ngIf="rowData.results.length > 0">{{rowData.contaminationType}}</td>
          <td>{{getRowColStringFromPos(rowData.positionRow-1,rowData.prositionCol-1)}}</td>
          <td>{{rowData.barcode}}</td>
          <td *ngFor="let channel of rowData.channels">
            {{getChannelResultForAnalysisTable(rowData, channel.gene)}}
          </td>
          <td>{{rowData.originalResult}}</td>
          <td>{{rowData.result}}</td>
          <td colspan="3"><textarea type="text" style="border: none;font-weight: unset" rows="2" id="commentArea"
              readonly>{{rowData.comments}}</textarea></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            No changes made
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div class="col-12">
      <div class="col-4">
      </div>
      <div class="col-4 pt-2 pb-0">
        <input class="batchInput" id="analysisVerificationField" pInputText [(ngModel)]="analysisVerifyPUID" type="text"
          maxlength="40" name="comment" placeholder="Enter User ID" />
      </div>
      <div class="col-4">
      </div>
    </div>
    <div class="col-12 pt-0 pb-0">
      <div class="col-4">
      </div>
      <div class="col-4 pt-0 pb-0">
        <input class="batchInput" pInputText type="password" [(ngModel)]="enteredPassword" maxlength="40"
          name="comment13" placeholder="Enter Password" (keyup.enter)="completeAnalysisProcess()" />
      </div>
      <div class="col-4">
      </div>
    </div>
  </div>
  <p-footer>
    <div class="col-6 pt-0">
      <p class="text-left text-danger m-0 warningTextAnalysis" [hidden]="!invalidVerifyPUIDCheck()">User ID must not be
        same as logged in PUID</p>
    </div>
    <div class="col-6 pt-0">
      <button pButton label="Confirm" (click)="completeAnalysisProcess()"
        [disabled]="isAnalysisConfirmDisabled()"></button>
      <button pButton label="Cancel" (click)="clearVerificationPUID()"></button>
    </div>
  </p-footer>
</p-dialog>

</div>

<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>